<script>
	import { base } from '$app/paths';
	import { page } from '$app/stores';
	import guides from './guides.json';
	import './help.css';
</script>

<div class="kdm-help">
	<nav class="help-nav" aria-label="KdmGen help guides">
		<a
			href={`${base}/kdmgen/help/`}
			aria-current={$page.url.pathname === `${base}/kdmgen/help/` ? 'page' : undefined}
			>Walk Throughs/Help</a
		>
		{#each guides as guide}
			<a
				href={`${base}/kdmgen/help/${guide.slug}/`}
				aria-current={$page.url.pathname === `${base}/kdmgen/help/${guide.slug}/`
					? 'page'
					: undefined}>{guide.title}</a
			>
		{/each}
	</nav>
	<slot />
</div>
